import { getCMSConfig } from '../../../util/cms';
/**
 * filterOnlyRelevantTariffs
 * @param unfilteredArray
 * @param fastestDslId
 * @returns
 */
export const filterOnlyRelevantTariffs = (unfilteredArray: string[], fastestDslId?: string) => {
    const tariffIds = getCMSConfig()?.tariffIds;

    if (!tariffIds) {
        return unfilteredArray;
    }

    const { telekom, vodafone } = tariffIds;
    const cmsMetacodes: string[] = Object.values(telekom).concat(Object.values(vodafone));
    const fiberIds = unfilteredArray.filter(metacode => metacode.match(/FIB-.+/g));
    const dslIds = fastestDslId
        ? [fastestDslId]
        : unfilteredArray.filter(metacode => metacode.match(/DSL-.+/g));
    const fiberIntersection = cmsMetacodes.filter(metacode => fiberIds.includes(metacode));

    return fiberIntersection.length
        ? Object.values(fiberIntersection).concat(Object.values(dslIds))
        : dslIds;
};
